import { render, staticRenderFns } from "./ServiceEndpointsForm.vue?vue&type=template&id=20e39e09&"
import script from "./ServiceEndpointsForm.vue?vue&type=script&lang=js&"
export * from "./ServiceEndpointsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports